
import {useCallback, useEffect, useState} from "react";
import React from "react";
import axios from "axios";
import Select from "react-select";
import "./style.css";
import {url} from "./BaseUrl"; // Import your CSS file
const tele = window.Telegram.WebApp;
tele.expand();
function IDS(){
    const [isLoading, setIsLoading] = useState(false); // State for loading indicator

    const [ids, setIds] = useState([]);
    const user = tele.initDataUnsafe?.user?.username || tele.initDataUnsafe?.user?.first_name + ' ' + tele.initDataUnsafe?.user?.last_name;
    async function getIDS() {
        setIsLoading(true);
        try {
            await axios.get(url+'/ids', {headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}})
                .then((res) => {
                    setIds(res.data);
                })
        }catch (error) {
            console.log(error);
        }finally {
            setIsLoading(false);
        }

    }useEffect(() => {
        getIDS();
    }, []);

    const [searchText,setSearchText] = useState("");
    const handleSearch = (value) => {
        setSearchText(value);
    }
    const [editingUserIndex, setEditingUserIndex] = useState(null);
    const [editedUserData, setEditedUserData] = useState({}); // State for edited user data

    // const handlesearchChange = (event) => {
    //     setSearchText(event.target.value);
    //     const filteredUsers = ids.filter(admin =>  {
    //         const id_user = admin.id_user || '';
    //         return id_user.includes(searchText);
    //     });
    //         const matchingUserIndex = filteredUsers.findIndex(user => user.id_user === (editingUserIndex !== null ? ids[editingUserIndex].id_user : null));
    //         setEditingUserIndex(matchingUserIndex !== -1 ? matchingUserIndex : null);
    //         setIds(filteredUsers);
    // }
    const [value,setvalue]=useState({
     ids:''
    });
    const handleChange = (event)=>{
        const {name,value}=event.target;
        setvalue((prevValues)=>({
            ...prevValues,
            [name]:value,
        }));
    }
    async function Add_IDS(){
        await axios.post(url+'/addid',value).then((res => {
                    if(res.data ==="exist"){

                        alert("تم إضافة رقم القيد بالفعل")
                        getIDS();
                    }
                    else
                        alert("تم إضافة رقم القيد بنجاح")
                }));
    }
    const delete_IDS = async(index)=>{
        if(window.confirm('Are you sure you want to delete this ID?')){
            try {
                await axios.delete(url+`/delete_id/${index}`, {headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}})
                    .then((res => {
                        if(res.data ==="exist")
                            alert("تم حدف رقم القيد بالفعل")
                        else
                            alert("تم حدف رقم القيد بنجاح")
                        getIDS();
                    }));
            } catch (error) {
                console.error(error);
            }
        }
    }
    return(
        <>
            {
                <div className="content-center flex flex-row justify-between w-auto h-auto">
                    <div className="bg-white rounded-b mx-auto w-full">
                        <div className="p-2 md:px-10 flex content-center justify-between  m-4" dir="rtl">
                            <h1 className="text-lg font-bold text-[#303BFF] text-right">
                                مرحباَ بك يا <span className="text-lg font-bold text-[#303BFF] text-right mr-2">{user}</span>
                            </h1>
                        </div>

                        <div className="p-2 md:px-8 flex justify-start  m-4" dir={"rtl"}>
                            <input type="Text" name='ids' value={value.ids} onChange={handleChange}
                                className="border-solid border-2 rounded-md w-1/3 max-sm:w-2/3 px-2 py-1"/>
                            <button  className="bg-green-500 hover:bg-green-700 text-white rounded p-2"
                                        onClick={Add_IDS}>إضافة
                            </button>
                        </div>
                        <div className="p-2 md:px-8 justify-center m-4 mb-6 bg-white rounded-xl">
                            {isLoading ? (
                                <div className="flex items-center justify-center"> {/* Center the content horizontally */}
                                  <img className="w-12 h-12 animate-spin mr-4" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" /> {/* Add margin for spacing */}
                                  <span className="text-xl font-bold">جاري التحميل...</span>
                              </div>
                            ):(
                                <table className="w-full text-md bg-white shadow-md rounded mb-4 table-fixed " dir="rtl">
                                    <thead className="flex flex-col items-center   w-full pl-4">
                                        <tr className="border-b text-center justify-between flex w-full  mb-4">
                                            <th className="p-3 px-4 w-1/8">#</th>
                                            <th className="p-3 w-1/2">رقم القيد</th>
                                            <th className="p-3 w-1/4">حالة</th>
                                        </tr>
                                    </thead>
                                    <tbody className="flex flex-col items-center  overflow-y-scroll h-72 max-h-96 w-full pl-3">
                                        {(ids.map((admin,index)=>(
                                        <tr className="text-center hover:bg-orange-100 flex w-full  justify-between mb-4">
                                                <td className="p-3 w-1/8 flex items-center justify-center">{index+1}</td>
                                                <td className="p-3 w-1/2 flex items-center justify-center">{admin.id_user}</td>
                                                <td className="p-3 w-1/4 flex items-center justify-center">{admin.used?' مستخدم':'غير مستخدم'}</td>
                                                <td className="p-3 w-1/4 flex flex-col items-center justify-center">
                                                    <button className="bg-red-500 hover:bg-red-700 text-white  p-2 rounded"
                                                            onClick={() => delete_IDS(admin.id_user)}>حذف</button>
                                                </td>
                                        </tr>
                                    )))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            }
        </>
    );

}

export default IDS
